'use strict';

import axios from 'axios';
import { handleError } from '@/_helpers/utils.js';

export default {
  namespaced: true,
  state() {
    return {
      data: null,
      loaded: false,
      error: null
    }
  },
  actions: {
    load(context, responseToken) {
      context.commit('set_loaded', false);
      context.commit('set_error', null);
      let promise;
      if (responseToken) {// передаётся при публичном отклике
        promise = axios.get(`/1.0/spec-public/feniche/test/${responseToken}`);
      } else {
        promise = axios.get(`/1.0/spec-private/feniche/response/${context.getters.response_id}`);
      }
      return promise
        .then(response => response.data)
        .then(data => {
          context.commit('set_data', data);
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          throw err;
        })
    }
  },
  mutations: {
    set_data(state, data) {
      state.data = data;
    },
    set_loaded(state, loaded) {
      state.loaded = loaded;
    },
    set_error(state, error) {
      state.error = error;
    }
  },
  getters: {
    data: (state) => state.data,
    error: (state) => state.error,
    loaded: (state) => state.loaded,
    response_id: (state, getters, rootState) => rootState.route.params.id,
  }
}